import { render, staticRenderFns } from "./BaseDropDown.vue?vue&type=template&id=5e87c684&scoped=true&"
import script from "./BaseDropDown.vue?vue&type=script&lang=js&"
export * from "./BaseDropDown.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropDown.vue?vue&type=style&index=0&id=5e87c684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e87c684",
  null
  
)

export default component.exports